import {
  FilterBarContainer,
  FilterBarLeftContent,
  FilterBarRightContent,
} from "./FilterBar.styled";
import { Select, Button, TextField, Table, SwitchMode } from "@ann/web-components";
import { useState, useMemo, useRef, useCallback, useEffect } from "react";
import { CATEGORIES } from "../../constants/promptConstants";

const FilterBar = ({ mode, setMode }) => {
  const [searchTermDepartments, setSearchTermDepartments] = useState("");
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [searchTermLastUpdate, setSearchTermLastUpdate] = useState("");
  const [selectedLastUpdate, setSelectedLastUpdate] = useState([]);
  const [searchTermOwner, setSearchTermOwner] = useState("");
  const [selectedOwner, setSelectedOwner] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [filtersKey, setFiltersKey] = useState(0);
  const searchTimeoutRef = useRef(null);

  const lastUpdateOptions = [
    { label: "Last 7 days", value: "last_7_days" },
    { label: "Last 30 days", value: "last_30_days" },
    { label: "This year", value: "this_year" },
  ];

  const ownerOptions = [
    { label: "John Doe", value: "john_doe" },
    { label: "Jane Smith", value: "jane_smith" },
    { label: "Mike Johnson", value: "mike_johnson" },
  ];

  const filteredLastUpdate = useMemo(() => {
    if (!searchTermLastUpdate.trim()) return lastUpdateOptions;
    const searchLower = searchTermLastUpdate.toLowerCase();
    return lastUpdateOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(searchLower) ||
        option.value.toLowerCase().includes(searchLower)
    );
  }, [searchTermLastUpdate]);

  const filteredOwner = useMemo(() => {
    if (!searchTermOwner.trim()) return ownerOptions;
    const searchLower = searchTermOwner.toLowerCase();
    return ownerOptions.filter(
      (owner) =>
        owner.label.toLowerCase().includes(searchLower) ||
        owner.value.toLowerCase().includes(searchLower)
    );
  }, [searchTermOwner]);

  const handleSearchLastUpdate = (searchValue) => {
    setSearchTermLastUpdate(searchValue);
  };

  const handleMultipleSelectionLastUpdate = (items) => {
    setSelectedLastUpdate(items);
  };

  const handleSearchOwner = (searchValue) => {
    setSearchTermOwner(searchValue);
  };

  const handleMultipleSelectionOwner = (items) => {
    setSelectedOwner(items);
  };

  const handleMultipleSelectionDepartments = (items) => {
    setSelectedDepartments(items);
  };

  const handleSearchChange = useCallback((value) => {
    setSearchValue(value);
    
    // Clear existing timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    
    // Set new timeout for 500ms debounce
    searchTimeoutRef.current = setTimeout(() => {
      // TODO: Add search callback here if needed
    }, 500);
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const handleClearAllFilters = () => {
    setSelectedDepartments([]);
    setSelectedLastUpdate([]);
    setSelectedOwner([]);
    setSearchTermDepartments("");
    setSearchTermLastUpdate("");
    setSearchTermOwner("");
    setSearchValue("");
    setFiltersKey((prev) => prev + 1);
    
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
  };

  const emptyOrValue = (arr) => (arr.length > 0 ? arr : undefined);

  return (
    <FilterBarContainer>
      <FilterBarLeftContent>
        <TextField
          iconLeft="search"
          onChange={handleSearchChange}
          size="small"
          placeholder="Search Prompts..."
          value={searchValue}
        />
        <Select
          key={`category-filter-${filtersKey}`}
          label="Category"
          onSelectionChange={handleMultipleSelectionDepartments}
          placeholder="Category"
          size="small"
          value={emptyOrValue(selectedDepartments)}
          width="auto" minWidth="139px"
        >
          <Select.Menu>
            {CATEGORIES.map((dept) => (
              <Select.Item
                key={dept.value}
                value={dept.value}
                label={dept.label}
              >
                {dept.label}
              </Select.Item>
            ))}
          </Select.Menu>
        </Select>
        <Select
          key={`last-update-filter-${filtersKey}`}
          label="Last Update"
          placeholder="Last Update"
          onSelectionChange={handleMultipleSelectionLastUpdate}
          size="small"
          value={emptyOrValue(selectedLastUpdate)}
          width="auto" minWidth="139px"
        >
          <Select.Menu>
            {filteredLastUpdate.map((option) => (
              <Select.Item
                key={option.value}
                value={option.value}
                label={option.label}
              >
                {option.label}
              </Select.Item>
            ))}
          </Select.Menu>
        </Select>
        <Select
          key={`owner-filter-${filtersKey}`}
          label="Owner"
          placeholder="Owner"
          onSelectionChange={handleMultipleSelectionOwner}
          size="small"
          value={emptyOrValue(selectedOwner)}
          width="auto" minWidth="144px"
        >
          <Select.Menu multipleChoice={true}>
            <Select.Search
              placeholder="Search a name"
              onChange={handleSearchOwner}
              label=""
            />
            {filteredOwner.map((owner) => (
              <Select.Item
                key={owner.value}
                value={owner.value}
                label={owner.label}
              >
                {owner.label}
              </Select.Item>
            ))}
          </Select.Menu>
        </Select>
        <Button
          icon=""
          iconLeft=""
          iconRight=""
          label="Clear Filters"
          size="medium"
          type="secondary"
          onClick={handleClearAllFilters}
        />
      </FilterBarLeftContent>
      <FilterBarRightContent>
        <SwitchMode
          mode={mode}
          onModeChange={setMode}
        />
      </FilterBarRightContent>
    </FilterBarContainer>
  );
};

export default FilterBar;
